import React from 'react';
import DCDetail from './DCDetail.js';

const InwardsDetail = ({ db, user }) => {
  return <DCDetail db={db} user={user} />;
};

export default InwardsDetail;
